// utils/useReferralTracking.ts
import { useEffect, useState } from 'react';
import { ReferralData, getUrlParams, saveReferralData, loadReferralData, sanitizeReferralData } from './referralUtils';

export const useReferralTracking = () => {
  const [referralData, setReferralData] = useState<ReferralData | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Check for URL parameters first
    const urlReferralData = getUrlParams();
    const hasUrlParams = Object.values(urlReferralData).some(value => value !== undefined);

    if (hasUrlParams) {
      // Sanitize URL params
      const sanitizedUrlData = sanitizeReferralData(urlReferralData);
      setReferralData(sanitizedUrlData);
      saveReferralData(sanitizedUrlData);
      console.log('Referral data captured from URL:', sanitizedUrlData);
    } else {
      // Load from cookies if no URL params
      const cookieReferralData = loadReferralData();
      if (cookieReferralData) {
        setReferralData(cookieReferralData);
        console.log('Referral data loaded from cookie:', cookieReferralData);
      }
    }
    
    setIsLoaded(true);
  }, []);

  return { referralData, isLoaded };
};
